<script lang="ts">
	import ArrowRight from 'lucide-svelte/icons/arrow-right';
	import type { WithoutChildren } from 'bits-ui';
	import { getEmblaContext } from './context.js';
	import { cn } from '$lib/utils.js';
	import { Button, type Props } from '$lib/components/ui/button/index.js';

	let {
		ref = $bindable(null),
		class: className,
		variant = 'outline',
		size = 'icon',
		...restProps
	}: WithoutChildren<Props> = $props();

	const emblaCtx = getEmblaContext('<Carousel.Next/>');
</script>

<Button
	{variant}
	{size}
	class={cn(
		'absolute h-8 w-8 touch-manipulation rounded-full border-none bg-[#194139] hover:bg-[#194139]/85',
		emblaCtx.orientation === 'horizontal'
			? '-top-12 right-4 sm:-right-12 sm:left-auto sm:top-1/2 sm:-translate-y-1/2'
			: '-top-12 left-1/2 -translate-x-1/2 rotate-90',
		className
	)}
	disabled={!emblaCtx.canScrollNext}
	onclick={emblaCtx.scrollNext}
	onkeydown={emblaCtx.handleKeyDown}
	bind:ref
	{...restProps}
>
	<ArrowRight class="h-4 w-4 stroke-background" />
	<span class="sr-only">Next slide</span>
</Button>
